registerComponent("sections/home-insights", function (component) {
/**
 * O corpo recebe o elemento raiz do componente em `component`; o build o
 * envolve em registerComponent(). Os antigos `params` viraram @props no Blade.
 *
 * O slick de 2020 (`slidesToShow: 2` / `slidesToScroll: 2`, `1` a partir do
 * `breakpoint: 767`, `infinite: false`) vira um `Asa.trilho`. O passo continua
 * sendo a JANELA inteira (`passo: 'pagina'`), e quantos cabem por janela quem
 * diz é o CSS — o trilho MEDE, não recebe. É o gêmeo de
 * `sections/home-contents`, com 2 por janela em vez de 3.
 *
 * ⚠️ DUAS caixas de pontos. O legado trocava o `appendDots` por breakpoint —
 * `.slider-dots-desk` (na coluna do título) fora do celular e o `.slider-dots`
 * do `blocks/slider-controls` dentro dele. O `Asa.trilho` aceita as duas e
 * escreve a mesma lista nas duas; quem mostra uma por vez é a folha.
 *
 * ⚠️ ESTE COMPONENTE NÃO RENDERIZA EM NENHUMA URL. O único call site é
 * `pages/help/index.blade.php:117`, e `pages/help` não renderiza
 * (`UnreferencedComponentsTest::test_pages_help_does_not_render`). Logo, nada
 * aqui é exercitado pelo `browser-check`: o que prova este arquivo é o
 * `yarn lint`, o `node --check` do bundle e o grep de dependência legada.
 * Candidato ao protocolo de remoção da Fase 9, junto de `sections/home-videos`,
 * `sections/slider-videos`, `modals/modal-contact`, `pages/help` e
 * `pages/wealth-planning`.
 */

const lista = component.querySelector('.slider');

if (lista) {
    Asa.trilho(lista, Object.assign(
        { itens: '[data-component-name="blocks/card-content"]', passo: 'pagina' },
        Asa.controlesDoTrilho(component.querySelector('[data-component-name="blocks/slider-controls"]')),
        {
            pontos: [
                component.querySelector('.slider-dots-desk'),
                component.querySelector('[data-component-name="blocks/slider-controls"] .slider-dots'),
            ].filter(Boolean),
        },
    ));
}

});
